export const CopyIcon = () => {
	return (
		<svg viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M18.0837 9.0415V9.0415C18.0837 7.27718 18.0837 6.39502 17.5656 5.82339C17.5216 5.77488 17.4753 5.72856 17.4268 5.6846C16.8551 5.1665 15.973 5.1665 14.2087 5.1665H9.16699C7.28137 5.1665 6.33857 5.1665 5.75278 5.75229C5.16699 6.33808 5.16699 7.28089 5.16699 9.16651V14.2082C5.16699 15.9725 5.16699 16.8547 5.68509 17.4263C5.72905 17.4748 5.77537 17.5211 5.82387 17.5651C6.39551 18.0832 7.27767 18.0832 9.04199 18.0832V18.0832"
				stroke="white"
			/>
			<rect x="12.917" y="12.9165" width="12.9167" height="12.9167" rx="2" stroke="white" />
		</svg>
	);
};
